import React, { useEffect, useState } from 'react';

import { Link, useHistory } from 'react-router-dom';

import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBIcon,
  MDBInput,
  MDBCard,
  MDBCardBody,
} from 'mdbreact';
import NavBar from '../../../components/NavBar';
import api from '../../../services/api';
import { format } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';
import Loading from '../../../components/Loading';

import Select from 'react-select';

import resolverMensagemErro from '../../../utils/resolverMensagemErro';
import RelatorioPdf from '../Components/RelatorioPdf';
import { toast } from 'react-toastify';
// LISTA DE ABORDAGENS EM QUE O AGENTE LOGADO PARTICIPA (EQUIPE),
// MAS NAO FOI ELE QUEM CADASTROU. SOMENTE VISUALIZACAO.
export default function App() {
  let history = useHistory();
  const [abordagens, setAbordagens] = useState([]);
  const [loading, setLoading] = useState(false);

  const [qtdTotal, setQtdTotal] = useState(0);
  const [page, setPage] = useState('1');

  const [selectBusca, setSelectBusca] = useState({ label: 'Todas' });

  const [idAbordagem, setIdAbordagem] = useState(null);
  const [searchAbordagem, setSearchAbordagem] = useState(false);

  const participacoesAbordagens = async () => {
    setLoading(true);
    const params = { pag: page };
    if (selectBusca.value === 'idabordagem') {
      if (idAbordagem === null) {
        setAbordagens([]);
        setLoading(false);
        setQtdTotal(1);
        return;
      }
      params.abordagem_id = idAbordagem;
    }

    // [#217] O setLoading(false) fica no finally: sem ele, uma falha do GET
    // deixava o spinner girando para sempre e sem mensagem nenhuma.
    try {
      let result = await api.get('/participacoes-abordagens', {
        params,
      });

      result.data.rows.map(abord => {
        const newRow = [];
        (abord.ocorrencia || []).forEach(oco => {
          if (oco.ativo === true) newRow.push(oco);
        });

        abord.ocorrencia = newRow;
      });

      setAbordagens(result.data.rows);

      setQtdTotal(Math.ceil(Number(result.data.count) / Number(10)));
    } catch (err) {
      toast.error(resolverMensagemErro(err));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    participacoesAbordagens();
  }, [page]);

  useEffect(() => {
    if (selectBusca.value === 'idabordagem') {
      setSearchAbordagem(true);
      setAbordagens([]);
      setPage(1);
      return;
    } else {
      setIdAbordagem(null);
      setSearchAbordagem(false);
    }
    page === 1 && participacoesAbordagens();
    setPage(1);
  }, [selectBusca]);

  useEffect(() => {
    participacoesAbordagens();
  }, []);

  return (
    <NavBar>
      <MDBContainer fluid>
        <MDBRow className="h4-responsive" center>
          Abordagens
        </MDBRow>
        <MDBRow center>Participações</MDBRow>

        <MDBCard>
          <MDBCardBody>
            <MDBRow className="align-items-center">
              <MDBCol
                className="mx-3 align-items-center justify-content-center"
                size="11"
                md="3"
              >
                <Select
                  options={[
                    { label: 'Todas', value: 'Todas' },
                    { label: 'ID ABORDAGEM', value: 'idabordagem' },
                  ]}
                  onChange={e => setSelectBusca(e)}
                  value={selectBusca}
                />
              </MDBCol>

              {searchAbordagem === true && (
                <>
                  <MDBCol col="12" md="6">
                    <MDBInput
                      label="Número da Abordagem"
                      outline
                      type="number"
                      maxLength="11"
                      onChange={e => setIdAbordagem(e.target.value)}
                      value={idAbordagem}
                    />
                  </MDBCol>
                  <MDBCol className="text-center">
                    <MDBBtn onClick={() => participacoesAbordagens()} size="sm">
                      Buscar
                    </MDBBtn>
                  </MDBCol>
                </>
              )}
            </MDBRow>
          </MDBCardBody>
        </MDBCard>

        <MDBRow
          style={{ borderRadius: '5px' }}
          className="p-2 mr-1 ml-1 mt-1 mr-md-3 ml-md-3 align-items-center grey darken-1  d-none d-md-flex text-white font-weight-bolder"
        >
          <MDBCol size="12" md="1">
            N:
          </MDBCol>
          <MDBCol size="12" md="4">
            Gerência / Ala
          </MDBCol>
          <MDBCol size="12" md="3">
            Início da Abordagem:
          </MDBCol>
          <MDBCol size="12" md="2">
            Ocorrências:
          </MDBCol>
          <MDBCol size="12" md="2"></MDBCol>
        </MDBRow>
        {loading === true ? (
          <Loading />
        ) : abordagens.length !== 0 ? (
          abordagens.map(abordagem => (
            <MDBRow
              key={abordagem.id}
              style={{ borderRadius: '5px' }}
              className="p-2 mr-1 ml-1 mt-1 mr-md-3 ml-md-3 align-items-center bg-white"
            >
              <MDBCol size="12" md="1">
                {abordagem.id}
              </MDBCol>
              <div className="col-12 col-md-4 mb-md-0 d-flex justify-content-between justify-content-md-start align-items-center">
                {`${abordagem.lotacao.gerencia.nome} / ${abordagem.lotacao.ala.nome}`}
              </div>
              <div className="col-12 col-md-3 mb-md-0 d-flex justify-content-between justify-content-md-start">
                <span className="d-sm-inline d-md-none mr-3">Dia Início</span>

                {format(
                  zonedTimeToUtc(
                    new Date(abordagem.dt_h_inicio),
                    'America/Sao_Paulo'
                  ),
                  'dd/MM/yyyy - HH:mm'
                )}
              </div>
              <div className="col-12 col-md-2 mb-md-0 text-center text-md-center font-weight-bolder">
                <span className="d-sm-inline d-md-none mr-3">Ocorrências:</span>

                {abordagem.ocorrencia.length}
              </div>

              <div className="col-12 col-md-2 mt-2 mt-md-0  d-flex justify-content-center justify-content-md-end align-items-center">
                <RelatorioPdf abordagemId={abordagem.id} className="mr-3" />

                <Link
                  to={`/abordagem/${abordagem.id}`}
                  className="blue-grey-text"
                >
                  <div
                    className="d-flex mr-3 align-items-center font-weight-bold"
                    style={{ cursor: 'pointer', color: '#59698d' }}
                  >
                    <MDBIcon far icon="eye" />

                    <div className="ml-2">Ver</div>
                  </div>
                </Link>
              </div>
            </MDBRow>
          ))
        ) : (
          <MDBRow center className="my-4 font-weight-bolder">
            Sem participações
          </MDBRow>
        )}
        {loading === true ? (
          ''
        ) : (
          <MDBRow center className="my-4 align-items-center">
            <div>
              Página {page} de {qtdTotal}
            </div>
            <MDBIcon
              className="mx-3"
              onClick={e => {
                if (page == 1) {
                  return;
                }
                setPage(Number(page) - 1);
              }}
              style={{
                fontSize: '30px',
                cursor: 'pointer',
              }}
              icon="angle-left"
            />
            |
            <MDBIcon
              className="mx-3"
              onClick={e => {
                if (page >= qtdTotal) {
                  return;
                }
                setPage(Number(page) + 1);
              }}
              style={{
                fontSize: '30px',
                cursor: 'pointer',
              }}
              icon="angle-right"
            />
          </MDBRow>
        )}
      </MDBContainer>
    </NavBar>
  );
}
